import { render, staticRenderFns } from "./BatchFileListViewModal.vue?vue&type=template&id=5790cff2"
import script from "./BatchFileListViewModal.vue?vue&type=script&lang=js"
export * from "./BatchFileListViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports